export const SITE = {
  name: "Advanced Coaching",
  tagline: "Elite coaching. Developing all abilities.",
  established: "Est. 2025",
  whatsapp: "447399023410",
  phone: "+44 7399 023 410",
  email: "advancedcoaching9@outlook.com",
  address: "Teesside, United Kingdom",
  socials: {
    facebook: "https://facebook.com/advancedcoaching",
    instagram: "https://instagram.com/advancedcoaching",
    tiktok: "https://tiktok.com/@advancedcoaching",
  },
};

export const SERVICES = [
  {
    slug: "one_to_one",
    title: "1-to-1 Coaching",
    blurb: "Personalised programmes built around your child's level, goals and position.",
    bullets: ["Tailored curriculum", "Video analysis", "Weekly progress"],
    icon: "Target",
    image: "https://images.pexels.com/photos/8941569/pexels-photo-8941569.jpeg",
    cta: "Book a Session",
    href: "/private-sessions",
  },
  {
    slug: "schools",
    title: "Schools Coaching",
    blurb: "Curriculum-aligned PE delivery and after-school clubs partnering with local schools.",
    bullets: ["Curriculum aligned", "Fully insured", "After-school clubs"],
    icon: "School",
    image: "https://images.pexels.com/photos/8941569/pexels-photo-8941569.jpeg",
    cta: "Partner with Us",
    href: "/contact",
  },
  {
    slug: "haf",
    title: "HAF Programme",
    blurb: "Coming 2026 — Holiday Activities and Food programme places for eligible families.",
    bullets: ["Free for eligible families", "Hot meal included", "Multi-sport offering"],
    icon: "HeartHandshake",
    image: "https://images.pexels.com/photos/32709238/pexels-photo-32709238.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    cta: "Register Interest",
    href: "/contact",
  },
];

export const TRUST_BADGES = [
  { label: "FA Qualified", icon: "ShieldCheck" },
  { label: "DBS Checked", icon: "BadgeCheck" },
  { label: "Safeguarding Trained", icon: "Shield" },
  { label: "First Aid Certified", icon: "HeartPulse" },
  { label: "Fully Insured", icon: "FileCheck" },
];

export const COACHES = [
  {
    slug: "fin",
    name: "Coach Fin",
    role: "Founder & Head Coach",
    bio: "A very determined coach with a drive for development in players. Also working part-time at Middlesbrough FC Academy and currently undergoing his UEFA B Licence.",
    badges: ["FA Level 2", "DBS", "Safeguarding"],
    image: "https://customer-assets.emergentagent.com/job_advanced-coaching/artifacts/hs3eo28m_original-2E94F65F-92AC-4309-B355-D417768378CE.jpeg",
  },
  {
    slug: "louis",
    name: "Coach Louis",
    role: "Coach",
    bio: "A very versatile coach able to work with all ages and abilities. Currently coaching Seaton Carew Under-18s, Louis has experience in all parts of the game.",
    badges: ["FA GK Level 1", "DBS", "Strength & Conditioning"],
    image: "https://customer-assets-lqy194kg.emergentagent.net/job_advanced-coaching/artifacts/sr6ozcj0_cags%20coaching%20photo.JPG",
  },
];

export const FAQS = [
  {
    q: "What ages do you coach?",
    a: "We coach players from age 6 right through to adults. Sessions are grouped by age and ability so every player is challenged and supported.",
  },
  {
    q: "Where are sessions held?",
    a: "All sessions are run in Billingham, Teesside. 1-to-1 sessions run at Bedford Terrace (Mon/Wed) and Bede College (Tue/Thu).",
  },
  {
    q: "How do payments work?",
    a: "You can pay online via card at the time of booking, or choose to pay at the session. We accept cash and card on the day.",
  },
  {
    q: "Are coaches qualified and DBS checked?",
    a: "Absolutely. Every coach holds at least an FA Level 1 qualification, is DBS checked, safeguarding trained and first-aid certified.",
  },
  {
    q: "Can I cancel a booking?",
    a: "Refunds are accepted up to 24 hours before the session start time. Any cancellations later than that will be charged in full.",
  },
  {
    q: "Will the HAF programme be available this year?",
    a: "We're working with the local council to launch HAF in 2026 — register your interest via the contact form and we'll keep you posted.",
  },
];

export const SERVICE_LABELS = {
  one_to_one: "1-to-1 Coaching",
  small_group: "Small Group",
  schools: "Schools Coaching",
  haf: "HAF Programme",
};
